import React from "react";
import { View } from "react-native";

function TransparentModal({ children }: { children?: React.ReactNode }) {
  return (
    <View className="absolute bottom-0 left-0 right-0 top-0 z-50 flex items-center justify-center bg-gray-50/70">
      {children}
    </View>
  );
}

export default TransparentModal;
